import {
  Component,
  OnInit,
  AfterViewChecked,
  OnDestroy,
  DoCheck,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { RightSideDrawerService } from '../right-side-drawer.service';
import usStateLocations from '../../../../assets/us-state-locations.json';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SessionService } from '../../session-service/session.service';
import { ToastrService, LoadingIndicatorService } from '@kpmg-tax/ui';
import { Messages } from '../../../shared/constants/messages';
import { Router } from '@angular/router';
import { role } from '../../../shared/constants/role-enum';
import { ClientUsersService } from 'src/app/client-users/client-users.service';

@Component({
  selector: 'add-client-user-form',
  templateUrl: './add-client-user-component.html',
  styleUrls: ['./add-client-user.component.scss'],
})
export class AddClientUserComponent
  implements OnInit, AfterViewChecked, OnDestroy, DoCheck {
  targetForm: FormGroup; // name of formGroup in template
  targetFormSubmitted: boolean = false;
  currentDate: Date = new Date();
  hireDateRequired: boolean = false;
  //isInsert: boolean = true;
  subscription: Subscription;
  employmentDatesError: boolean = false;
  isClient: boolean = false;
  noResults: boolean;
  clients: any = [];
  engagementClient: string = '';
  isClientSelected: boolean = false;
  //emailPattern = /[a-zA-Z0-9_.+-,;]+@(?:(?:[a-zA-Z0-9-]+\.,;)?[a-zA-Z]+\.,;)?(kpmg|KPMG|Kpmg|kPmg|kpMg|kpmG|KPmg|KpMg|KpmG|kPMg|kPmG|kpMG|KPMg|kPMG|KPmG|KpMG)\.com/;
  //isContractor: boolean = false;
  Email: string;
  IsEmailExists: boolean = false;
  IsSignInNameExists: boolean = false;
  userRoles: Array<number> = [];
  championRole: number = role.champion;
  clientManager: number = role.clientManager;
  adminRole: number = role.admin;

  IsRoleEnabled: boolean = false;
  public states = usStateLocations.map(function (item) {
    return item.abbreviation;
  });
  isDisplayNameEntered: boolean = false;
  //isClientMode: boolean = false;
  //clientName: string;

  constructor(
    public rightSideDrawerService: RightSideDrawerService,
    public _clientUsersService: ClientUsersService,
    private formBuilder: FormBuilder,
    public sessionService: SessionService,
    public _toastrService: ToastrService,
    public _router: Router,
    private _loader: LoadingIndicatorService,
  ) { }

  ngOnInit() {
    // this.isClientMode =
    //   this.sessionService.getSession(SESSION_CONST.ISCLIENTMODE) === 'true';
    // if (this.isClientMode) {
    //   this.clientName = this.rightSideDrawerService.singleRowAddData;
    // }
    this._clientUsersService.GetClients().subscribe((data: any) => {
      this.clients = data.result;
    });

    //this.isClient = this._clientUsersService.isClient;
    this.ResetFormData();
  }

  ngDoCheck() {
    let value =
      this.targetForm.controls.signinname.value ||
      this.targetForm.controls.email.value;

    if (value) {
      if (this.isClient) {
        this.rightSideDrawerService.setMandatoryField(true, 'Add Client User');
      } else {
        this.rightSideDrawerService.setMandatoryField(true, 'Add KPMG User');
      }
    } else {
      this.rightSideDrawerService.setMandatoryField(false, '');
    }
  }

  SetRoles(roleId: any) {
    this.IsRoleEnabled = true;
    if (this.userRoles.filter(x => x === roleId).length === 0) {
      this.userRoles.push(roleId);
    } else {
      this.userRoles = this.userRoles.filter(x => x !== roleId);
    }
  }
  // reset and create the form group on start up.
  ResetFormData() {
    this.targetForm = this.formBuilder.group({
      userId: [''],
      signinname: [
        '',
        [
          Validators.required,
          Validators.pattern(
            '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$',
          ),
        ],
      ],
      //clientName: ['', this.isClient ? Validators.required : null],
      email: [
        '',
        [
          Validators.required,
          Validators.pattern(
            '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$',
          ),
        ],
        // : [
        //     Validators.required,
        //     Validators.compose([
        //       Validators.required,
        //       Validators.pattern(this.emailPattern),
        //     ]),
        //   ],
      ],
      displayName: ['', Validators.required],
      // IsContractor: ['', this.isContractor ? Validators.required : false],
      engagementId: [''],
    });
    // setTimeout(() => {
    //   this.subscription = this._clientUsersService.isInsert.subscribe(x => {
    //     if (x === true) {
    //       this.isInsert = true;
    //     } else {
    //       this.isInsert = false;
    //       let userData = this._clientUsersService.selectedUserDetails;
    //       this.targetForm.patchValue({
    //         userId: userData.userId,
    //         name: userData.userName,
    //         //clientName: userData.clientName,
    //         //IsContractor: this.isContractor,
    //         email: userData.email,
    //       });
    //     }
    //   });
    // });
  }

  // IsContractor() {
  //   this.isContractor = !this.isContractor;
  // }

  trimSpecialChar(ctrl: any) {
    this.targetForm.controls[ctrl].setValue(
      this.targetForm.get(ctrl).value.replace(/[^a-zA-Z0-9-()._/ ]/g, ''),
    );
  }
  trimSpecialCharName(ctrl: any) {
    this.targetForm.controls[ctrl].setValue(
      this.targetForm.get(ctrl).value.replace(/[^a-zA-Z0-9-,'.()_ ]/g, ''),
    );
  }
  UpdateEmail(event: any) {
    this.targetForm.controls['email'].setValue(event.target.value);
  }

  get f() {
    return this.targetForm?.controls;
  }
  checkSigninName(ctrl: any) {
    let val = this.targetForm.get(ctrl).value;
    if (val) {
      this._clientUsersService.CheckSignInName(val).subscribe((data: any) => {
        if (data.result != null) {
          this.IsSignInNameExists = data.result;
        }
      });
    }
  }
  checkEmail() {
    if (this.Email != null) {
      this._clientUsersService.CheckEmail(this.Email).subscribe((data: any) => {
        if (data.result != null) {
          this.IsEmailExists = data.result;
        }
      });
    }
  }
  // Delete empty properties to clean form data to send to back-end API
  // Blank values sent to the back-end API gives errors.
  cleanTargetFormToPost = () => {
    let formData = this.sessionService.removeNullEmptyValues(
      this.targetForm.value,
    );

    formData.clientName = this.sessionService.getSession('clientName');
    let emailsplit = formData.email.split('@');
    formData.email = emailsplit[0] + '@' + emailsplit[1].toLowerCase();

    //formData.IsContractor = this.isContractor;
    formData.roleIds =
      this.userRoles.length > 0 ? this.userRoles.join(',') : '';
    formData.engagementId = this.sessionService.getSession('engagementId');
    return formData;
  };

  // This function runs when "Add user" button is clicked
  postRightSideDrawerData = () => {
    const formData = this.cleanTargetFormToPost()
    this._clientUsersService.CreateUser(this.cleanTargetFormToPost()).subscribe(
      data => {
        // Refresh data table on page
        if (data.success) {
          this._toastrService.setSuccessMessage(
            Messages.Admin.ClientUser.AddClientUserSuccess,
          );
        } else {
          this._toastrService.setErrorMessage(
            Messages.Admin.ClientUser.AddClientUserFailure,
          );
        }
        this._clientUsersService.refreshTable();
        this.rightSideDrawerService.closeRightSideDrawer();
      },
      // Show in console if there is an error given from the back end.
      error => {
        console.log(error);
        this._toastrService.setErrorMessage(Messages.Admin.User.BackEndError);
      },
    );
    // Change variable to note a form submission attempt was made.
    this.targetFormSubmitted = true;
  };

  public resetRightSideDrawerData = () => {
    //this.targetForm.reset();
    this.targetFormSubmitted = false;
  };

  ngAfterViewChecked() {
    // Refresh form inputs if drawer is opened or loaded.
    if (this.rightSideDrawerService.triggerRightSideDrawerClick) {
      this.rightSideDrawerService.triggerRightSideDrawerClick = false; // Set trigger to false so that this action is only performed once. Without this, the form would keep resetting on every change on any input.
      this.resetRightSideDrawerData();
      // if (this.isClientMode) {
      //   this.clientName = this.rightSideDrawerService.singleRowAddData;
      // }
    }
  }
  displayNameChange() {
    let displayName = this.targetForm.get('displayName').value;
    if (displayName && displayName.trim().length > 0) {
      this.isDisplayNameEntered = true;
    } else {
      this.isDisplayNameEntered = false;
    }
  }

  // chkclientName() {
  //   return this.clientName.trim() !== '';
  // }

  ngOnDestroy(): void {
    //this.subscription.unsubscribe();
  }

  // searchExistingClients = (searchPhrase$: Observable<any>) =>
  //   searchPhrase$.pipe(
  //     debounceTime(200), // Wait 250 milliseconds for typing to stop
  //     distinctUntilChanged(), // Only continue if the current search term is different that it was before the user started typing
  //     tap(term => {
  //       // Remove "no results" message in case it was displayed from the previous search
  //       this.noResults = false;
  //     }),
  //     switchMap(term => {
  //       if (term !== '') {
  //         // Process the search term entered
  //         return this.searchClients(term).pipe(
  //           switchMap(data => {
  //             this.engagementClient = term;
  //             return of(data);
  //           }),
  //           catchError(() => {
  //             this.noResults = true;
  //             return of([]);
  //           }),
  //         );
  //       } else {
  //         return of([]);
  //       }
  //     }),
  //   );

  // Filter clients autosuggest
  // private searchClients(term: any): Observable<any> {
  //   if (this.clients) {
  //     return of(
  //       this.clients.filter((item: any) =>
  //         item.clientName.toLowerCase().includes(term.toLowerCase()),
  //       ),
  //     );
  //   } else {
  //     return of([]);
  //   }
  // }

  // onClientSelected($event: any) {
  //   this.engagementClient = $event.item.clientName;
  //   this.isClientSelected = true;
  // }

  // format for clients search
  //   clientFormatter = (result: any) =>
  //     typeof result.clientName === 'undefined' ? result : result.clientName;
}
